import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import { REDIRECT_PATHS } from 'src/app/routes/routes.constants'

export const useRedirectExternalURL = () => {
  const location = useLocation()
  const [isDoingRedirect, setIsDoingRedirect] = useState(true)

  useEffect(() => {
    if (Object.keys(REDIRECT_PATHS).includes(location.pathname)) {
      window.location.href = REDIRECT_PATHS[location.pathname]
    } else {
      setIsDoingRedirect(false)
    }
  }, [])

  return { isDoingRedirect }
}
